/**
 * Handler de erro self-contained da biblioteca.
 * Em vez de depender do SnackbarEvent/i18n do app anfitrião, dispara um
 * CustomEvent que o componente raiz (Checklist.vue) escuta para exibir um
 * snackbar interno e reemitir como evento `@erro` para o app.
 *
 * Mantém a mesma assinatura do antigo utils/error-handler: errorHandler(msg|err).
 */
export default function errorHandler(err) {
  const message = (err && err.message) ? err.message : err;
  document.dispatchEvent(new CustomEvent('checklist:error', { detail: { message } }));
  return message;
}
